var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-dropdown',[_c('a-avatar',{staticClass:"avatar",attrs:{"size":40,"icon":"user"},on:{"click":(e) => e.preventDefault()}}),_c('a-menu',{attrs:{"slot":"overlay"},slot:"overlay"},[_c('a-menu-item',[_c('div',{on:{"click":_vm.Loginout}},[_vm._v("退出登陆")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }